import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { ZeeFontMedium } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';

export const viewCrewBtn = (showCrew: boolean) => css`
  border: none;
  background: ${colors.Transparent};
  padding-top: ${showCrew ? '8px' : '12px'};
  cursor: pointer;
  color: ${colors.Lavender};
  ${MQ.MobileXs} {
    ${ZeeFontMedium(12, 18)};
  }
  ${MQ.MediaSm} {
    ${ZeeFontMedium(14, 20)};
  }
  ${MQ.MediaXl} {
    ${ZeeFontMedium(16, 22)};
  }
`;

export const consumptionMetadataWrapper = (spaceX = '') => css`
  ${MQ.MobileXs} {
    padding: 14px 16px 10px;
    margin-bottom: 16px;
  }
  ${MQ.MediaSm} {
    ${spaceX ? `padding: 0 ${spaceX}px` : ''}
    padding-left: 0;
  }
  ${MQ.MediaMd} {
    margin-bottom: 24px;
  }
`;
